






import { Component, Vue } from 'vue-property-decorator';
import API from '@/Api';

@Component
export default class PayrollClosingDate extends Vue {
    public item: any = '';

    public mounted() {
        API.Instance
            .get('api/payroll-closing-date')
            .then((response) => {
                this.item = response.data;
            });
    }
}
